// constants
import { SubCourseActionTypes } from "./constants";

export interface SubCourseActionType {
  type:
    | SubCourseActionTypes.API_RESPONSE_SUCCESS
    | SubCourseActionTypes.API_RESPONSE_ERROR
    | SubCourseActionTypes.UPDATE_SUB_COURSE
    | SubCourseActionTypes.CREATE_SUB_COURSE
    | SubCourseActionTypes.GET_SUB_COURSE
    | SubCourseActionTypes.DELETE_SUB_COURSE;
  payload: {} | string;
}

interface subCourseDetails {
  id: string;
  name: string;
  courseId: string;
}

// common success
export const subCourseApiResponseSuccess = (
  actionType: string,
  data: subCourseDetails | {}
): SubCourseActionType => ({
  type: SubCourseActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const subCourseApiResponseError = (
  actionType: string,
  error: string
): SubCourseActionType => ({
  type: SubCourseActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createSubCourse = (
  name: string,
  courseId: string
): SubCourseActionType => ({
  type: SubCourseActionTypes.CREATE_SUB_COURSE,
  payload: { name, courseId },
});

export const getSubCourse = (): SubCourseActionType => ({
  type: SubCourseActionTypes.GET_SUB_COURSE,
  payload: {},
});

export const deleteSubCourse = (id: string): SubCourseActionType => ({
  type: SubCourseActionTypes.DELETE_SUB_COURSE,
  payload: { id },
});
export const updateSubCourse = (
  id: string,
  name: string,
  courseId: string
): SubCourseActionType => ({
  type: SubCourseActionTypes.UPDATE_SUB_COURSE,
  payload: { id, name, courseId },
});
